<template>
  <div class="modal fade" id="ZoneModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true" ref="ZoneModalRef">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ selectedItem ? 'Modifier' : 'Ajouter' }} une zone</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <Form ref="zoneForm" @submit="soumettre" :validation-schema="zoneSchema">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">Code zone <span class="text-danger">*</span></label>
                  <Field name="code_zone" v-model="code_zone" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le code de la zone" :disabled="!!selectedItem" />
                  <ErrorMessage name="code_zone" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">Libellé <span class="text-danger">*</span></label>
                  <Field name="libelle_zone" v-model="libelle_zone" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le libellé" />
                  <ErrorMessage name="libelle_zone" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">Marché <span class="text-danger"></span></label>
                  <Field name="marche_id" v-slot="{ field }" v-model="marche_id">
                    <Multiselect :options="marches" :searchable="true" v-model="field.value" v-bind="field"
                      placeholder="Sélectionner un marché" />
                  </Field>
                  <ErrorMessage name="marche_id" class="text-danger" />
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-3 text-md-end text-xl-end text-sm-center col-sm-12">
                <button type="submit" class="btn btn-primary w-100">{{ selectedItem ? 'Modifier' : 'Enregistrer' }}</button>
              </div>
            </div>
          </Form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, watch, onMounted } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import Multiselect from "@vueform/multiselect";
import { hideModal, success, error } from "@/utils/utils";
import * as Yup from "yup";
import axios, { AxiosError } from "axios";

export default defineComponent({
  name: "ZoneModal",
  components: { Form, Field, ErrorMessage, Multiselect },
  props: { item: { type: [String, Number, null], default: null } },
  setup: (props, { emit }) => {
    const zoneSchema = Yup.object().shape({
      code_zone: Yup.string().required("Le code zone est obligatoire"),
      libelle_zone: Yup.string().required("Le libellé est obligatoire"),
      marche_id: Yup.number().notRequired(),
    });
    const zoneForm = ref<any | null>(null);
    const code_zone = ref("");
    const libelle_zone = ref("");
    const marche_id = ref(null);
    const marches = ref([]);
    const selectedItem = ref<any>(null);
    const ZoneModalRef = ref<null | HTMLElement>(null);

    const resetForm = () => {
      code_zone.value = "";
      libelle_zone.value = "";
      marche_id.value = null;
      selectedItem.value = null;
    };

    const getMarches = async () => {
      try {
        const response = await axios.get("/api/marches");
        if (response.data && response.data.data) {
          marches.value = response.data.data.map((el: any) => ({
            value: el.id,
            label: el.nomMarche,
          }));
        }
      } catch (err) {
        error(err instanceof Error ? err.message : String(err));
      }
    };

    const getZone = async (code: string) => {
      try {
        // TODO: Ajouter route GET zone/:code au backend
        const response = await axios.get(`zone/${code}`);
        if (response.data && response.data.data) {
          const data = response.data.data;
          code_zone.value = data.code_zone || "";
          libelle_zone.value = data.libelle_zone || "";
          marche_id.value = data.marche_id || null;
        }
      } catch (err) {
        error(err instanceof Error ? err.message : String(err));
      }
    };

    watch(() => props.item, async (newValue) => {
      if (newValue !== null && newValue !== undefined) {
        await getZone(newValue as string);
      } else {
        resetForm();
      }
    }, { immediate: true });

    onMounted(() => {
      getMarches();
    });

    const soumettre = async (values, { resetForm }) => {
      try {
        // TODO: Ajouter routes POST/PUT au backend
        if (selectedItem.value && selectedItem.value.code_zone) {
          const response = await axios.put(`zone/${selectedItem.value.code_zone}`, values);
          if (response.data && response.data.data) {
            success("La zone a été modifiée avec succès");
            resetForm();
            hideModal(ZoneModalRef.value);
            emit("close");
          }
          else {
            error("Une erreur est survenue"); 
          }
        } else {
          const response = await axios.post("zone", values);
          if (response.data && response.data.data) {
            success("La zone a été enregistrée avec succès");
            resetForm();
            hideModal(ZoneModalRef.value);
            emit("close");
          }
          else {
            error("Une erreur est survenue");
          }
        }
      } catch (err) {
        error(err instanceof AxiosError ? err.response?.data?.message || "Une erreur est survenue" : "Une erreur est survenue");
      }
    };

    return { code_zone, libelle_zone, marche_id, marches, selectedItem, ZoneModalRef, soumettre, zoneSchema, zoneForm };
  },
});
</script>
<style src="@vueform/multiselect/themes/default.css"></style>

